import AppManagementRequest from './AppManagementRequest';
import { AppComponent } from './AppManagementModel';
//param @app : AppManagementModel
//param @createdBy: user profile from useIdentify()
//component : AppComponent
export default class ComponentUpdateRequest extends AppManagementRequest {
	constructor(app, createdBy, component = null) {
		super(app, createdBy);
		this.component = component ?? new AppComponent();
	}
}
